<template>
  <generic-modal
    size
    :title="$t('document')"
    icon="file alternate"
    image="/images/icons/document.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("type") }}</label>
            <div class="ui selection dropdown" ref="type_dropdown">
              <input type="hidden" name="type" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div>
          <div class="field">
            <label for>{{ $t("description") }}</label>
            <textarea
              name="description"
              rows="2"
              v-model="description"
            ></textarea>
          </div>
          <!-- <div class="field">
            <label for>{{ $t("name") }}</label>
            <input type="text" name="name" v-model="name" />
          </div>-->
        </div>
        <h4 class="ui dividing header">{{ $t("files") }}</h4>
        <div class="ui selection list">
          <div
            class="item"
            v-on:click="download_file(file)"
            v-for="(file, index) in files"
            :key="index"
          >
            <div
              class="ui red right floated mini icon button"
              v-on:click.stop="remove_file(file, index)"
            >
              <i class="trash icon"></i>
            </div>
            <img
              class="ui avatar image"
              :src="
                '/images/icons/file_types/' +
                  (file.fileType.includes('image')
                    ? 'image.png'
                    : file.fileType.includes('pdf')
                    ? 'pdf.jpeg'
                    : 'file.png')
              "
            />
            <div class="content">
              <div class="header">{{ file.filename }}</div>
              <div class="description">
                {{ $t("size") }} {{ file.fileSize | sizeFromKB }}.
              </div>
            </div>
          </div>
        </div>
        <file-pond
          name="file"
          ref="pond"
          :label-idle="$t('click or drop files here')"
          v-bind:allow-multiple="true"
          v-bind:allow-revert="false"
          v-bind:server="{
            url: api_host,
            timeout: enterprise_setup.upload_timeout,
            process: {
              url: '/student_document/do-upload',
              method: 'POST',
              chunkUploads: true,
              headers: {
                'x-access-token': token_session,
              },
              withCredentials: false,
            },
          }"
          v-on:error="filepond_error"
          v-on:processfile="filepond_process"
        />

        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { local_api, enterprise_setup, api_host, stringify } from "@/utils";
import filters from "@/filters";
import GenericModal from "@/components/GenericModal";
import vueFilePond from "vue-filepond";
import { v4 } from "uuid";
// Import FilePond styles
import "filepond/dist/filepond.min.css";

const FilePond = vueFilePond();

export default {
  name: "StudentDocumentModal",
  components: {
    "generic-modal": GenericModal,
    FilePond,
  },
  filters: filters,
  computed: {
    form() {
      let vm = this;
      return window.jQuery(vm.$refs.form).form({
        fields: {
          // name: ["empty"],
          type: ["empty"],
        },
      });
    },
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  props: { student_in: Object, document_in: Object },
  data() {
    return {
      configuration: {},
      // name: "",
      type: "",
      description: "",
      files: [],
      api_host: api_host,
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = vm.form.form("validate form");

        if (!isValid) reject();
        else {
          local_api(vm, "post", "/student_document/do-save", {
            i: vm.document_in ? vm.document_in.uuid : undefined,
            t: vm.type,
            s: vm.student_in.uuid,
            // n: vm.name,
            d: vm.description,
            f: vm.files,
          })
            .then((document) => {
              vm.$emit("succedded", document);
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    filepond_error(a, b) {
      console.log("error", a, b);
    },
    filepond_process(event, inst) {
      let x1 = this.$refs.pond;
      console.log(x1, inst);
      if (inst.serverId) {
        let r = JSON.parse(inst.serverId);
        if (!r.success) console.log(r.error);
        else {
          this.files.push({
            file_id: v4(),
            server_file: r.data,
            filename: inst.filename,
            filenameWithoutExtension: inst.filenameWithoutExtension,
            fileExtension: inst.fileExtension,
            fileType: inst.fileType,
            fileSize: inst.fileSize,
          });
        }
        x1.removeFiles().then((r) => {
          console.log(r);
        });
      }
    },
    download_file(file) {
      console.log(file);
    },
    remove_file(file, index) {
      this.files.splice(index, 1);
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/student_document/do-get-configuration", {})
      .then((types) => {
        let vls = types.map((t) => {
          return {
            name: t.name,
            value: t.type_id,
          };
        });
        window
          .jQuery(vm.$refs.type_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.type = value;
            },
          });

        if (vm.document_in.type_id) {
          window
            .jQuery(vm.$refs.type_dropdown)
            .dropdown("set selected", vm.document_in.type_id);
        }
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });

    if (vm.document_in && vm.document_in.uuid) {
      // vm.name = vm.document_in.name;
      vm.type = vm.document_in.type_id;
      vm.description = vm.document_in.description;
      vm.files = vm.document_in.files;
    }
  },
  watch: {},
};
</script>
